<template>
    <div id="msn" v-if="contact">
        <div v-for="message in messages" class="col-12" :key="message.id">
            <div
                :class="
                    message.from == contact.id
                        ? 'd-flex justify-content-end'
                        : 'd-flex justify-content-start'
                "
            >
                <div
                    :class="`card-message p-2 m-2 ${
                        message.from == contact.id
                            ? 'user-destination received float-right'
                            : `user-auth sent sent-color${message.from} right float-left`
                    }`"
                    :style="`background:${
                        message.from != contact.id ? getColor(message.from) : ''
                    }`"
                >
                    <p class="m-0 mb-2">
                        <span class="font-weight-bold float-left mr-3">
                            {{
                                message.from == contact.id
                                    ? "Você"
                                    : message.from_contact.name
                            }}
                        </span>
                        <small class="font-weight-light float-right">{{
                            message.created_at | moment("DD/MM/YYYY HH:mm")
                        }}</small>
                    </p>
                    <div class="row px-3">
                        <p v-html="message.text"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 load-text" style="display: none">
            <hollow-dots-spinner
                :animation-duration="3000"
                :size="60"
                :color="'#fb8994'"
            />
        </div>
        <div v-if="messages.length <= 0" class="col-12">
            <h3 class="text-muted">
                Diga olá
                {{ type == "contatos" ? `para ${contact.name}` : "no grupo" }}
                😀
            </h3>
        </div>
    </div>
    <div style="height: 57vh; overflow: hidden" v-else>
        <div class="text-center">
            <h3>
                Escolha {{ type == "contatos" ? "uma pessoa" : "um grupo" }} ao
                lado para iniciar uma conversa.
            </h3>
        </div>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    components: {
        HollowDotsSpinner,
    },
    props: {
        contact: {
            type: Object,
        },
        type: {
            type: String,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return { colorContacts: [] };
    },
    mounted() {
        this.scrollToBottom();
    },
    methods: {
        scrollToBottom() {
            setTimeout(() => {
                if (document.getElementById("msn")) {
                    document.getElementById("msn").scroll({
                        top: document.getElementById("msn").scrollHeight,
                        left: 0,
                        // behavior: "smooth",
                    });
                }
            }, 50);
        },
        getColor(id) {
            var classColor = `sent-color` + id;
            var styleElem = document.head.appendChild(
                document.createElement("style")
            );

            if (this.colorContacts[id] == null) {
                this.colorContacts[id] = this.randomColor();

                styleElem.innerHTML = `.${classColor}::before {
                                 border-right-color:${this.colorContacts[id]} !important;
                border-top-color:${this.colorContacts[id]}!important;}`;

                return this.colorContacts[id];
            } else {
                styleElem.innerHTML = `.${classColor}::before {
                                 border-right-color:${this.colorContacts[id]} !important;
                border-top-color:${this.colorContacts[id]}!important;}`;
                return this.colorContacts[id];
            }
        },
        randomColor() {
            let color = "#";
            for (let i = 0; i < 3; i++)
                color += (
                    "0" +
                    Math.floor(
                        ((1 + Math.random()) * Math.pow(16, 2)) / 2
                    ).toString(16)
                ).slice(-2);
            return color;
        },
    },
    watch: {
        contact(contact) {
            this.scrollToBottom();
        },
        messages(messages) {
            this.scrollToBottom();
        },
    },
};
</script>

<style lang="scss" scoped>
.card-message {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    color: #343435;
    background-clip: border-box;
    border: 1px solid #fdfdff !important;
    border-radius: 1rem;
}
::-webkit-scrollbar-track {
    background-color: #f4f4f4;
}
::-webkit-scrollbar {
    width: 5px;
    background: #f4f4f4;
}
::-webkit-scrollbar-thumb {
    background: #979797;
    border-radius: 25em;
}

.direct-chat-info {
    display: block;
    margin-top: 15px;
}
.user-destination {
    background: #bbdefb;
}
.user-auth {
    background: #b2dfdb;
}
.msn {
    overflow-y: scroll;

    ul {
        list-style-type: none;
        padding: 5px;

        li {
            &.message {
                margin: 10px 0;
                width: 100%;

                .text {
                    max-width: 200px;
                    border-radius: 5px;
                    padding: 12px;
                    display: inline-block;
                }

                &.received {
                    text-align: right;

                    .text {
                        background: #b2b2b2;
                    }
                }

                &.sent {
                    text-align: left;

                    .text {
                        background: #81c4f9;
                    }
                }
            }
        }
    }
}
.user-auth.sent:before {
    content: "";
    position: absolute;
    top: 0;
    left: -4px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    /* border-right-color: #b2dfdb;
    border-top-color: #b2dfdb; */
}
.user-destination.received:before {
    content: "";
    position: absolute;
    top: 0;
    right: -6px;
    -moz-transform: scaleY(-1);
    -o-transform: scaleY(-1);
    -webkit-transform: scaleY(-1);
    transform: scaleY(-1);
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: #bbdefb;
    border-bottom-color: #bbdefb;
}

#msn {
    height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;
}

@media (min-width: 767px) AND (max-width: 1200px) {
    #msn {
        height: 50vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
}
</style>
